var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column"},[_c('language'),_c(_vm.currentComponent,{tag:"component",on:{"next":function($event){return _vm.nextScreen()},"chosen":function($event){return _vm.versionChosen()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }